<template>
    <div>
        <slot v-if="initSuccess"></slot>
    </div>
</template>

<script>
export default {
    name:'lazy',
    props:{
        time:{
            default:0
        }
    },
    data() {
        return {
            initSuccess: false
        }
    },
    created() {
        this.initSlot();
    },
 
    methods: {
        initSlot() {
            let timer = setTimeout(()=> {
                clearTimeout(timer);
                this.initSuccess = true;
            }, (Number(this.time || 0)));
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/lazyComponents.vue